import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import { useMemo } from "react";
import { ChannelPreview, Channels, PageByLanguage } from "@/queries/RockHallTV";
import { RhtvChannelPreviewQuery, RhtvChannelsQuery, RhtvPageByLanguageQuery } from "@/__generated__/graphql";
import { ABSOLUTE_PATHS } from "@/core/constants";
import { getDefaultRHTVVideo, getUrlLocale, mergePreviewChannel } from "@/core/utils";
import RockHallTVView from "./RockHallTV/RockHallTVView";

// Channels only reach this template as previews, where the seed node is the autosave revision,
// so the real channel ID and locale come from Faust's preview URL params.
const getPreviewParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    channelId: params.get('p'),
    language: getUrlLocale(params.get('previewPathname') ?? ''),
  };
};

const RockHallTVChannelPreview: FaustTemplate<any> = ({ loading }: FaustPageProps<any>) => {
  const pageData = useFaustQuery<RhtvPageByLanguageQuery>(PageByLanguage);
  const channelData = useFaustQuery<RhtvChannelPreviewQuery>(ChannelPreview);
  const channels = useFaustQuery<RhtvChannelsQuery>(Channels);

  const page = pageData?.rhNodeByUri?.__typename === 'Page' ? pageData.rhNodeByUri : null;
  const published = channels?.rhtvChannels?.nodes || [];

  const merged = useMemo(() => {
    if (!channelData?.preview) return null;
    return mergePreviewChannel(published, channelData.preview, channelData.channel?.slug);
  }, [channelData, channels]);

  if (loading) return;

  return (
    <RockHallTVView
      page={page}
      channels={merged?.channels || published}
      defaultChannel={merged?.channel || null}
      defaultVideo={getDefaultRHTVVideo(merged?.channel || null)}
      isPreview
    />
  );
};

RockHallTVChannelPreview.queries = [
  {
    query: PageByLanguage,
    variables: () => ({ uri: ABSOLUTE_PATHS.RRTV, language: getPreviewParams().language }),
  },
  {
    query: ChannelPreview,
    variables: () => ({ channelId: getPreviewParams().channelId }),
  },
  {
    query: Channels,
    variables: () => ({ language: getPreviewParams().language }),
  },
];

export default RockHallTVChannelPreview;
